const ChristianFeeData = {
    coursefee: "1,57,880",
    hostelfee: "2,21,640",
};
export default ChristianFeeData;
